export function useAprendizById(id?: number, queryEnabled = true) {
  return useQuery<Aprendiz, Error>({
    queryKey: ["aprendiz", id],
    enabled: !!id && queryEnabled,
    queryFn: async () => {
      if (!id) throw new Error("No id");
      const { data } = await axiosInstance.get(`/aprendices/${id}`);
      return data;
    },
  });
}
export interface AprendizOption {
  id: number;
  nombre: string;
}

export const useAprendicesOptions = (search: string, page = 1, limit = 20) => {
  return useQuery<{ data: AprendizOption[]; total: number }, Error>({
    queryKey: ["aprendices-select", search, page, limit],
    queryFn: async () => {
      const res = await axiosInstance.get("/aprendices/select-options", {
        params: { search, page, limit },
      });
      return res.data;
    },
  });
};
import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";
import type { Aprendiz } from "@interfaces/user.interface";

export interface AprendicesResponse {
  data: Aprendiz[];
  total: number;
}

export const useAprendices = (page: number, limit: number, search: string) => {
  return useQuery<AprendicesResponse, Error>({
    queryKey: ["aprendices", page, limit, search],
    queryFn: async () => {
      const response = await axiosInstance.get("/aprendices", {
        params: { page, limit, search },
      });
      return response.data;
    },
    placeholderData: keepPreviousData,
  });
};

export function useCargaMasivaExcelAprendices() {
  return useMutation({
    mutationKey: ["cargaMasivaExcelAprendices"],
    // Debe recibir un objeto con formData y idClienteFinal
    mutationFn: async ({
      formData,
      idClienteFinal,
    }: {
      formData: FormData;
      idClienteFinal: number;
    }) => {
      const res = await axiosInstance.post(
        `/aprendices/masivo?idClienteFinal=${idClienteFinal}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return res.data;
    },
  });
}

export function useCargaMasivaExcelAprendicesPrograma() {
  return useMutation({
    mutationKey: ["cargaMasivaExcelAprendicesPrograma"],
    mutationFn: async ({
      formData,
      idPrograma,
      idClienteFinal,
    }: {
      formData: FormData;
      idPrograma: number;
      idClienteFinal: number;
    }) => {
      const res = await axiosInstance.post(
        `/aprendices/masivo-programa?idPrograma=${idPrograma}&idClienteFinal=${idClienteFinal}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return res.data;
    },
  });
}
